import React from 'react';
import PropTypes from 'prop-types';
import { POPUPS } from '../../../containers/renewals/RenewalPageWrapper/constants';
import DialogApprovalRequired from './dialogs/DialogApprovalRequired/DialogApprovalRequired';
import DialogSignatureRequired from './dialogs/DialogSignatureRequired/DialogSignatureRequired';
import DialogCloseRenewal from './dialogs/DialogCloseRenewal/DialogCloseRenewal';
import DialogCreateAgreementPdf from './dialogs/DialogCreateAgreementPdf/DialogCreateAgreementPdf';

const ConfirmationDialogPresenter = (props) => {
  return !!props.popup ? (
    <div>
      <DialogApprovalRequired
        onClose={props.onClose}
        onAccept={props.onAccept}
        open={props.popup === POPUPS.APPROVAL_REQUIRED}
        data={props.popupData}
      />
      <DialogSignatureRequired
        onClose={props.onClose}
        onAccept={props.onAccept}
        open={props.popup === POPUPS.AUTO_APPROVAL}
        data={props.popupData}
      />
      <DialogCloseRenewal
        onClose={props.onClose}
        onAccept={props.onAccept}
        open={props.popup === POPUPS.CLOSE}
      />
      <DialogCreateAgreementPdf
        onClose={props.onClose}
        onAccept={props.onAccept}
        open={props.popup === POPUPS.CREATEAGREEMENT}
      />
    </div>
  ) : null;
};

ConfirmationDialogPresenter.propTypes = {
  popup: PropTypes.string,
  onClose: PropTypes.func,
  onAccept: PropTypes.func,
  popupData: PropTypes.object
};

export default ConfirmationDialogPresenter;
